define(function (require) {
	"use strict";

	var LobController = require("personalization-user-management-controllers/LobController");
	var LpaController = require("personalization-user-management-controllers/LpaController");
	var LobEditController = require("personalization-user-management-controllers/LobEditController");
	var LpaEditController = require("personalization-user-management-controllers/LpaEditController");
	var Privileges = require("codeTables/privileges.json");
	var LE = require("app");
	var CONST = require("const");

	function FeaturesConfig() {

		//---------------------------features--------------------------
		var LOB_Configuration = {
			id: "LOB_Configuration",
			isEnabled: _isLobConfigurationEnabled,
			permissions: [Privileges.privilegeIDs.EDIT_AC_LOB],
			anchorSelector: "[data-personalization='LOB']",
			anchorController: LobController,
			editController : LobEditController
		};

        var LPA_Configuration = {
            id: "LPA_Configuration",
            isEnabled: _isLpaConfigurationEnabled,
            permissions: [Privileges.privilegeIDs.EDIT_LPA_PROFILES_ASSIGNMENT],
            anchorSelector: "[data-profilespersonalization='PROFILES']",
            anchorController: LpaController,
            editController : LpaEditController
        };

		//---------------------------features functions--------------------------
		function _isAcUserAccount() {
			return CONST.SOURCE_ENUM.LE === LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.USERS_SOURCE);
		}

        function _isLobConfigurationEnabled() {
            return _isAcUserAccount() && (LE.sessionManager.hasLobFeature() || LE.siteSettings.lobSettings.hasLobSettingEnabled());
        }

        function _isLpaConfigurationEnabled(){
            return LE.sessionManager.hasLpaProfilesAssignmentFeature();
        }

        function _hasLpaProfileAssignPrivilege(){
            return LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.EDIT_LPA_PROFILES_ASSIGNMENT);
        }

        function _profilePageConfig(){
            var result = (_isLpaConfigurationEnabled() && _hasLpaProfileAssignPrivilege()) ? [LPA_Configuration] : [LOB_Configuration];
            return result;
        }

		var pages = {
			PeopleList: [LOB_Configuration],
			SkillsTable: [LOB_Configuration],
			AgentGroupsList: [LOB_Configuration],
			ProfileList: _profilePageConfig(),
			LobList: [LOB_Configuration]
		};

		return {
			pages: pages
		};

	}

	return FeaturesConfig;
});
